import { SealCheck } from "@phosphor-icons/react";

// Text-based recognition badges — names the hosts' actual platform statuses in the
// site's own style. Deliberately no copied badge artwork: Airbnb/Vrbo/misterb&b
// terms restrict their badge graphics to their own platforms. If official artwork
// is ever provided (e.g. Booking.com Traveller Review Award kit), swap it in here.
const BADGES = [
  { platform: "Airbnb", status: "Superhost" },
  { platform: "Vrbo", status: "Premier Host" },
  { platform: "misterb&b", status: "Fabul'Host" },
  { platform: "Booking.com", status: "Traveller Review Award · 9.6" },
];

export const HostBadges = ({ dark = false, className = "" }) => (
  <div data-testid="host-badges" className={className}>
    <p className={`overline mb-4 ${dark ? "text-sage" : "text-emerald-soft"}`}>
      Top-rated on the platforms you know
    </p>
    <div className="flex flex-wrap gap-2.5">
      {BADGES.map((b) => (
        <span
          key={b.platform}
          data-testid={`host-badge-${b.platform.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm ${
            dark ? "border-sand/20" : "border-emerald/15 bg-sand"
          }`}
        >
          <SealCheck size={16} weight="fill" className={dark ? "text-gold" : "text-sunset"} />
          <span className={dark ? "text-sand/70" : "text-emerald-soft"}>{b.platform}</span>
          <span className={`font-semibold ${dark ? "text-sand" : "text-emerald"}`}>{b.status}</span>
        </span>
      ))}
    </div>
  </div>
);

export default HostBadges;
